import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import IDS from '../__tests__/ids';
import { Icon } from 'legacy-packages/ft-cb';
import { AssignedIconWithTooltip } from 'chameleon/ui-stack/ui/assessments/icons-with-tooltip';

import {
  AdminCoordNoSchoolClassesAlert,
  NoStudentsAlert,
} from '../NoDataAlerts';
import './styles.scss';

/**
 * Show the section summary each section.
 * This contains the name of the section and how many watched and didn't watch the AP Daily video.
 * */
const SectionsContainer = ({ classProgress, showContainer }) => {
  if (!(classProgress || []).length) {
    return (
      <div
        data-test-id={IDS.SECTION_ROW}
        className={cn('section-summary-container flex-row space-between', {
          show: showContainer,
        })}
      >
        <AdminCoordNoSchoolClassesAlert />
      </div>
    );
  }

  return (
    (classProgress &&
      classProgress
        .slice()
        .sort((a, b) => a.className.localeCompare(b.className))
        .map(
          ({
            classId: sectionId,
            className: sectionName,
            assigned,
            totalStudents,
            watchedStudents,
          }) => (
            <div
              key={sectionId}
              data-test-id={IDS.SECTION_ROW}
              className={cn(
                'section-summary-container flex-row space-between',
                { show: showContainer },
              )}
            >
              <div className="flex-vertical-align space-between">
                <div className="flex-vertical-align fixed-width header">
                  <AssignedIconWithTooltip
                    target={`section-popover-assigned-icon-${sectionId}`}
                    disable={!assigned}
                    className={cn('assigned-icon', {
                      'not-visible': !assigned,
                    })}
                    data-test-id={IDS.ASSIGNED_ICON}
                  />
                  <div data-test-id={IDS.SECTION_NAME}>{sectionName}</div>
                </div>
                {totalStudents ? (
                  <Fragment>
                    <div
                      className="flex-vertical-align fixed-width header unwatched"
                      data-test-id={IDS.UNWATCHED_COLUMN}
                    >
                      <Icon name="person" />
                      <div data-test-id={IDS.UNWATCHED_COLUMN_TEXT}>
                        {totalStudents - watchedStudents} Unwatched
                      </div>
                    </div>
                    <div
                      className="flex-vertical-align fixed-width header watched"
                      data-test-id={IDS.WATCHED_COLUMN}
                    >
                      <Icon name="person" />
                      <div data-test-id={IDS.WATCHED_COLUMN_TEXT}>
                        {watchedStudents} Watched
                      </div>
                    </div>
                  </Fragment>
                ) : (
                  <div>
                    <NoStudentsAlert className="school-has-noclass-students" />
                  </div>
                )}
              </div>
            </div>
          ),
        )) ||
    null
  );
};

SectionsContainer.displayName = 'SectionsContainer';

SectionsContainer.propTypes = {
  className: PropTypes.string,
  watchedStudents: PropTypes.array,
  unwatchedStudents: PropTypes.array,
  showContainer: PropTypes.bool,
};

SectionsContainer.defaultProps = {
  className: '',
  watchedStudents: [],
  unwatchedStudents: [],
  showContainer: false,
};

export default SectionsContainer;
